export default "__VITE_ASSET__CyIX14TZ__"